<template>
    <table class="table table-hover dynamic-table">
        <thead class="bg-gray-light">
            <tr>
                <th>
                    <sort-by
                        title="ID"
                        :sort="getSort('id')"
                        name="id"
                    />
                </th>
                <th>
                    <span>Contact List</span>
                </th>
                <th>
                    <sort-by
                        title="Contacts Count"
                        :sort="getSort('total')"
                        name="total"
                    />
                </th>
                <th>
                    <sort-by
                        title="Unique Clickers"
                        :sort="getSort('unique')"
                        name="unique"
                    />
                </th>
                <th>
                    <sort-by
                        title="Initial Clickers"
                        :sort="getSort('initial')"
                        name="initial"
                    />
                </th>
                <th>
                    <sort-by
                        title="New Clickers"
                        :sort="getSort('new')"
                        name="new"
                    />
                </th>
                <th>
                    <sort-by
                        title="New Clickers<br/>Revenue"
                        :sort="getSort('new_revenue_amount_number')"
                        name="new_revenue_amount_number"
                    />
                </th>
                <th>
                    <sort-by
                        title="New Clickers<br/>Profit"
                        :sort="getSort('new_profit_number')"
                        name="new_profit_number"
                    />
                </th>
                <th>
                    <sort-by
                        title="Repeat Clickers"
                        :sort="getSort('repeat')"
                        name="repeat"
                    />
                </th>
                <th>
                    <sort-by
                        title="Repeat Clickers<br/>Revenue"
                        :sort="getSort('repeat_revenue_amount_number')"
                        name="repeat_revenue_amount_number"
                    />
                </th>
                <th>
                    <sort-by
                        title="Repeat Clickers<br/>Profit"
                        :sort="getSort('repeat_profit')"
                        name="repeat_profit"
                    />
                </th>
                <th>
                    <sort-by
                        title="Non Clickers"
                        :sort="getSort('non')"
                        name="non"
                    />
                </th>
                <th>
                    <sort-by
                        title="Non Clickers<br/>with Duplicates"
                        :sort="getSort('dupes')"
                        name="dupes"
                    />
                </th>
                <th class="text-right">
                    <sort-by
                        title="Updated At"
                        :sort="getSort('updated_at')"
                        name="updated_at"
                    />
                </th>
                <th class="text-right"></th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-if="items.length > 5"
                class="without-color"
            >
                <th :colspan="colspanTotal">Total</th>
                <th>{{ totalItems.total }}</th>
                <th>{{ totalItems.unique_percent }}% ({{ totalItems.unique }})</th>
                <th>{{ totalItems.initial }}</th>
                <th>{{ totalItems.new }}</th>
                <th>${{ totalItems.new_revenue_amount }} ({{ totalItems.new_revenue_count }})</th>
                <th>${{ totalItems.new_profit }} (${{ totalItems.new_cost }})</th>
                <th>{{ totalItems.repeat }}</th>
                <th>${{ totalItems.repeat_revenue_amount }} ({{ totalItems.repeat_revenue_count }})</th>
                <th>${{ totalItems.repeat_profit }} (${{ totalItems.repeat_cost }})</th>
                <th>{{ totalItems.non }}</th>
                <th colspan="3">{{ totalItems.with_dupes }}</th>
            </tr>
        </tbody>
        <clicker-report-table-row-component
            v-for="(value, idx) in items"
            :key="idx"
            :value="value"
        />
        <tfoot>
            <tr>
                <th :colspan="colspanTotal">Total</th>
                <th>{{ totalItems.total }}</th>
                <th>{{ totalItems.unique_percent }}% ({{ totalItems.unique }})</th>
                <th>{{ totalItems.initial }}</th>
                <th>{{ totalItems.new }}</th>
                <th>${{ totalItems.new_revenue_amount }} ({{ totalItems.new_revenue_count }})</th>
                <th>${{ totalItems.new_profit }} (${{ totalItems.new_cost }})</th>
                <th>{{ totalItems.repeat }}</th>
                <th>${{ totalItems.repeat_revenue_amount }} ({{ totalItems.repeat_revenue_count }})</th>
                <th>${{ totalItems.repeat_profit }} (${{ totalItems.repeat_cost }})</th>
                <th>{{ totalItems.non }}</th>
                <th colspan="3">{{ totalItems.with_dupes }}</th>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import EventBus from '../../event-bus';
import SortBy from '../subcomponents/SortBy';
import ClickerReportTableRowComponent from './ClickerReportTableRowComponent';

export default {
    filters: {
        capitalize: function (value) {
            if (!value) return '';
            value = value.toString();

            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    },

    components: {
        ClickerReportTableRowComponent,
        SortBy,
    },

    props: {
        report: {
            type: Object,
            default: () => ({}),
        },

        reportBy: {
            type: [String, Number],
            default: '',
        },
    },

    data: function () {
        return {
            colspanTotal: 2,
            sortDirections: [],
            items: [],
            totalItems: [],
        };
    },

    watch: {
        reportBy() {
            this.reportBy && this.getReportByType();
            this.setSort(null);
        },
    },

    mounted() {
        this.getReportByType();
        EventBus.$on('setSort', (data) => {
            this.setSort(data);
        });
    },

    methods: {
        getReportByType() {
            this.totalItems = this.report.totals[this.reportBy];
            this.items = this.report.items.map((item) => {
                let newItem = item[this.reportBy];

                if (item.entity && newItem) {
                    newItem.entity = item.entity;
                    newItem.id = item.entity.id;
                    newItem.top_cats = item.top_cats;
                }

                return newItem;
            });
        },
        setSort(key) {
            let direction = null;
            if (!this.sortDirections[key]) {
                direction = 'desc';
            } else if (this.sortDirections[key] === 'desc') {
                direction = 'asc';
            }
            this.sortDirections = [];
            this.sortDirections[key] = direction;
            this.items = direction ? _.orderBy(this.items, [key], [direction]) : this.items;
        },
        getSort(key) {
            return this.sortDirections[key] ? 'sort-' + this.sortDirections[key] : 'unsorted';
        },
    },
};
</script>

<style scoped>
table > thead > tr > th {
    vertical-align: middle;
}
.table > tbody + tbody {
    border-top: none;
}
</style>
